module.exports = __webpack_public_path__ + "img/default.689575a0.png";